import Vue from "vue";
import auth from "./auth";
import logina from "./login";
import test from "./test";

Vue.prototype.$authAjax = auth;
Vue.prototype.$logina = logina;
Vue.prototype.$test = test;



